import { platformOutlineLayer, platformPerimeterLayer } from '@components/map/layers/platforms/platform.layer';
import { useAppSelector } from '@hooks/redux.hooks';
import { selectPlatformPerimeterFeatures } from '@redux/config/config.selectors';
import { isFeatureCollection } from '@utils/map/map.utils';
import { Layer, Source } from 'react-map-gl/mapbox';

import { SourceNameEnum } from '@/types/map.types';

export function PlatformLayer() {
  const platformFeatures = useAppSelector(selectPlatformPerimeterFeatures);

  if (!isFeatureCollection(platformFeatures)) return null;

  return (
    <Source id={SourceNameEnum.PLATFORMS} type="geojson" data={platformFeatures}>
      <Layer {...platformOutlineLayer} />
      <Layer {...platformPerimeterLayer} />
    </Source>
  );
}
